import {Modal} from "@shopify/polaris";
import React from "react";
import intl from "../../../../i18n/intl";
const UpgradePlanModal = ({pointData,setPointData,handleChatDsc}) => {

  return (
    <div className="upgrade_new_feature">
      <Modal
        open={pointData.more}
        onClose={() => setPointData((prevValue)=>({...prevValue,more:false}))}
        title={intl.get('Ai Description optimization')}
        primaryAction={{
          content: intl.get("Apply"),
          onAction: () => {
            handleChatDsc()
            setPointData((prevValue)=>({...prevValue,more:false}))
          },
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => setPointData((prevValue)=>({...prevValue,more:false})),
          },
        ]}
      >
        <Modal.Section>
        <p style={{fontSize:'14px'}}>{`This AI description optimization will cost 20 points. Are you sure you want to proceed? (Remaining points: ${pointData.points})`}</p>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default UpgradePlanModal;
